module.exports = __webpack_public_path__ + "static/media/blank.2a4544cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/blank.svg
// module id = 2168
// module chunks = 0